/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'

const SYSTEM_KEYWORDS = [
  'help',
  'aide',
  'info',
  'ping',
  'start',
  'stop',
  'arret',
  'quit',
  'cancel',
  'unsubscribe',
  'unsub',
  'done',
  'end',
  'certify',
  'certified',
  'session',
  'leave',
  'results',
  '22333',
  '37607'
]
/*
 * Not all of these are common session keywords. But all of these are allowed
 * as session keywords, but not as global keywords.
 */
const COMMON_SESSION_KEYWORD = [
  'true',
  'false',
  'yes',
  'no',
  'other',
  'keyword',
  'code',
  'what',
  'the',
  'cast',
  'vote'
]

const Keyword = self => {
  /*
   * @namespace Model
   * @mixin
   *
   */
  return {
    initKeyword () {
      // keep track of initial keyword
      self.initialKeyword = __guard__(self.get('keyword'), x => x.toLowerCase())
    },

    resetKeyword (keywordProps) {
      self.set(keywordProps)
      return self.initKeyword()
    },

    isAutoKeyword () {
      return self.isBlankKeyword() || (self.get('keyword') === 'Auto Keyword') || !!self.get('auto_keyword')
    },

    isBlankKeyword () {
      return (self.get('keyword') === undefined) || (self.get('keyword') === '')
    },

    isSystemKeyword () {
      let keyword
      if (!(keyword = self.get('keyword'))) { return false }
      return _.contains(SYSTEM_KEYWORDS, keyword.toLowerCase())
    },

    isCommonSessionKeyword () {
      let keyword
      if (!(keyword = self.get('keyword'))) { return false }
      return _.contains(COMMON_SESSION_KEYWORD, keyword.toLowerCase())
    },

    checkKeywordAvailability () {
      const deferred = Backbone.$.Deferred()

      const keyword = __guard__(self.get('keyword'), x => x.toLowerCase())

      if (self.initialKeyword === keyword) {
        // If this is the original keyword assigned, then resolve it immediately
        deferred.resolve(true)
      } else {
        Backbone.ajax({ url: `/keywords/${keyword}/status` })
          .done(function (obj) {
            const keywordAvailable = (obj.keyword != null ? obj.keyword.state : undefined) === 'available'
            return deferred.resolve(keywordAvailable, obj.keyword != null ? obj.keyword.message : undefined, obj.keyword != null ? obj.keyword.poll_permalink : undefined)
          }).fail(error => deferred.reject(error.message))
      }

      return deferred.promise()
    },

    validateKeyword (opts) {
      if (opts == null) { opts = {} }
      _.defaults(opts, {
        allowBlank: true,
        sessionKeyword: false
      }
      )

      if (!opts.allowBlank && self.isBlankKeyword()) {
        return 'Keyword cannot be blank'
      } else if (!opts.sessionKeyword && self.isCommonSessionKeyword()) {
        return 'This is a system keyword'
      } else if (self.isSystemKeyword()) {
        return 'This is a system keyword'
      }
    },

    isKeywordAlphaNumeric () {
      return (/[a-zA-Z]/).test(self.get('keyword'))
    }
  }
}

export default Keyword

function __guard__ (value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
